module.exports = __webpack_public_path__ + "static/media/bonusSpins_40_50.10891f5c.png";